import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import { t } from '~/helpers';

import InicioPitStop from './form';

const formRef = createRef();

class EdicaoInicio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      params: {},
      isValidating: false,
    };
  }

  setIsValidating = (status) => {
    this.setState({ isValidating: status });
  };

  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  async handleCloseModal() {
    await this.setState({ open: false, isValidating: false });
    this.props.close();
  }

  async hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
    this.props.close();
  }

  async handlesub() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
    await formRef.current.submitForm();
  }

  render() {
    const { open, params } = this.state;
    const { isValidating } = this.state;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 600}
      >
        <DialogTitle>
          <Typography variant="h6">
            {t('s.cadastro.pitstop.atendimento')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <InicioPitStop
            data={params}
            reference={formRef}
            close={() => {
              this.handleCloseModal();
              this.props.update(params);
            }}
            cancelarAcao={() => this.hancleCancelarAcao()}
            setIsValidating={this.setIsValidating}
          />
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={(event) => {
              this.setIsValidating(true);
              formRef.current.submitForm(event);
            }}
            disabled={isValidating}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>
          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(EdicaoInicio);
